export default "__VITE_ASSET__EkgcYa0e__"